import React, { FC } from 'react';
import { MantineProvider, MantineThemeOverride } from '@mantine/core';
import * as experianColors from './experianColors';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';

// Mantine uses open colors (open-source color scheme): https://yeun.github.io/open-color/
// Mantine explanation here: https://mantine.dev/theming/colors/

const experianTheme: MantineThemeOverride = {
	black: '#333333',
	colors: {
		blue: experianColors.blue,
		indigo: experianColors.purple,
		violet: experianColors.purple,
		grape: experianColors.magenta,
		pink: experianColors.raspberry,
		red: experianColors.red,
		green: experianColors.green,
		yellow: experianColors.yellow,
		cyan: experianColors.sapphire,
		teal: experianColors.teal,
		lime: experianColors.lime,
		orange: experianColors.orange,
		gray: experianColors.gray,
		dark: experianColors.gray,
	},
	radius: {
		xs: '3px',
		sm: '4px',
		md: '6px',
		lg: '8px',
		xl: '12px',
	},
	fontSizes: {
		xs: '.75rem',
		sm: '.875rem',
		md: '1rem',
		lg: '1.25rem',
		xl: '1.5rem',
	},
	headings: {
		sizes: {
			h1: {
				fontSize: '1.5rem',
				lineHeight: '2rem',
			},
			h2: {
				fontSize: '1.25rem',
				lineHeight: '1.75rem',
			},
			h3: {
				fontSize: '1.125rem',
				lineHeight: '1.5rem',
			},
		},
	},
};

export const ThemeProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
	<MantineProvider theme={experianTheme} defaultColorScheme="light">
		{children}
	</MantineProvider>
);
